import React from "react";

const VersionContext = React.createContext();

const {Provider} = VersionContext;

export {Provider};
export default VersionContext;